export const currencies = [
  { id: 1, name: '£' },
  { id: 2, name: '$' },
  { id: 3, name: '€' },
];
